const i18n = {
	parseFormat:"%Y-%m-%d %H:%i:%s",
	parseDateFormat: "%Y-%m-%d", /*EKM*/
	parseDateTimeFormat: "%Y-%m-%d %H:%i:%s", /*EKM*/
	parseTimeFormat:"%H:%i:%s",
};


export default i18n;